/**
 * Created by fwt on 2019/7/30.
 */
 import React,{Component} from "react"
 import {InputItem,Tabs, Picker,List,Radio,Toast,TextareaItem} from 'antd-mobile';
import cityData from "../../utils/areaData"
 import {recruitAdddriver,recruitAddpartner} from '../../service/memberService';
 import './style.less';
 import {connect} from "react-redux";
const mtlogo = require('../../common/image/mtlogo.png');
const gzhewm = require('../../common/image/gzhewm.jpg');
const xcxewm = require('../../common/image/xcxewm.jpg');
const zmtb = require('../../common/image/zmtb.png');
let area = "";
let area1 = "";//所在地区
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
 @connect(
     state => ({userInfo: state.userInfo})
 )
 export default class RecruitDrivers extends Component{
     constructor(props) {
         super(props);
         this.state={
            sexType: [
                {value: 0, label: '女'},
                {value: 1, label: '男'},
            ],
            workType: [
                {value: 1, label: '城际'},
                {value: 2, label: '城内'},
            ],
             tabs : [
                 { title:"民途出行"},
                 { title: "司机招募" },
                 { title: "合作伙伴" },
             ],
             userName:"",
             gender:'',
             age:'',
             phone:'',
             driverAge:'',
             businessType:'',
             area:'',
             note:'',
             userName1:"",
             phone1:"",
             area1:'',
             project:'',
         }
     }
    componentDidMount() {}
    
    getArea(labels){
        // area = labels.join(',');//取value代码
        area = '';
        labels.map((res)=>{
            area += res
        });
        return labels.join(',');
    }
    getArea1(labels){
        area1 = '';
        labels.map((res)=>{
            area1 += res
        });
        return labels.join(',');
    }
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    submit(){
        const {userName,gender,age,phone,driverAge,businessType,note} = this.state;
        if(userName === ""){ Toast.info("请填写姓名");return}
        if(gender === ""){Toast.info("请选择性别");return}
        if(age === ""){Toast.info("请填写年龄");return}
        if(phone === ""){Toast.info("请填写联系方式");return}
        if(!phoneReg.test(this.state.phone.replace(/\s/ig, ''))){Toast.info("请填写正确的联系方式");return}
        if(driverAge === ""){Toast.info("请填写驾龄");return}
        if(businessType === ""){Toast.info("请选择意向业务");return}
        if(area === ""){Toast.info("请选择意向区域");return}
        let params = {
            userName:userName,
            gender:gender,
            age:age,
            phone:phone.replace(/\s/ig, ''),
            driverAge:driverAge,
            businessType:businessType,
            area:area,
            note:note,
        };
        recruitAdddriver(params).then((res)=>{
            if (res.data.code === '0000') {
                Toast.success('提交成功',3,()=>this.clearText());
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    submit1(){
        const {userName1,phone1,project} = this.state;
        if(userName1 === ""){ Toast.info("请填写姓名");return}
        if(phone1 === ""){Toast.info("请填写联系方式");return}
        if(!phoneReg.test(this.state.phone1.replace(/\s/ig, ''))){Toast.info("请填写正确的联系方式");return}
        if(area1 === ""){Toast.info("请选择意向区域");return}
        if(project === ""){Toast.info("请填写从业经验");return}
        let params = {
            userName:userName1,
            phone:phone1.replace(/\s/ig, ''),
            area:area1,
            project:project,
        };
        recruitAddpartner(params).then((res)=>{
            if (res.data.code === '0000') {
                Toast.success('提交成功',3,()=>this.clearText());
            }else{
                Toast.info(res.data.msg,3)
            }
        })
        console.log(params.data)
    }
    clearText(){
        this.setState({
            userName:"",
            gender:'',
            age:'',
            phone:'',
            driverAge:'',
            businessType:'',
            area:'',
            note:'',
            userName1:"",
            phone1:"",
            area1:'',
            project:'',
        });
    }
     render() {
         return (
             <div className="recruit">
                <div className="tit">
                    <span className="title"><img src={zmtb} className="zmtb"/>合作加盟</span>
                    <p className="join">COOPERATION TO JOIN</p>
                </div>
                 <Tabs prerenderingSiblingsNumber={false} tabs={this.state.tabs} swipeable={false} >
                    <div>
                        <p className="info">
                        民途出行网约车平台隶属于云南顺佳捷汽车租赁服务有限公司，公司拥有自主开发技术团队，已于2018年取得交通运输部等七部委联合签发的《网络预约出租汽车经营许可证》，并已相继获得昆明、贵阳、昭通、保山、攀枝花、南昌、兴义、文山、南宁、呼和浩特、毕节、桂林等80多个市县的网约车牌照，是涵盖市内、长途、商旅、乡村，以及定制出行等多元化一站式的网约车平台。
                        </p>
                    </div>
                    <div>
                        <InputItem
                            clear
                            placeholder="请输入您的姓名"
                            value={this.state.userName}
                            onChange={v => this.inputChange(v, 'userName')}
                        ><span className="yuan"></span>姓名</InputItem>
                        <div className="list">
                            <div className="radiolabel" ><span className="yuan"></span>性别</div>
                            {this.state.sexType.map((res, i) => (
                                <Radio key={i} checked={this.state.gender === res.value}
                                    onChange={() => this.setState({gender: res.value})}>
                                    {res.label}
                                </Radio>
                            ))}
                        </div>
                        <InputItem
                            clear
                            type="number"
                            placeholder="请输入您的年龄"
                            value={this.state.age}
                            onChange={v => this.inputChange(v, 'age')}
                        ><span className="yuan"></span>年龄</InputItem>
                        <InputItem
                            clear
                            type="phone"
                            placeholder="请输入联系方式"
                            value={this.state.phone}
                            onChange={v => this.inputChange(v, 'phone')}
                        ><span className="yuan"></span>联系方式</InputItem>
                        <InputItem
                            clear
                            type="number"
                            placeholder="请输入您的驾龄"
                            value={this.state.driverAge}
                            onChange={v => this.inputChange(v, 'driverAge')}
                        ><span className="yuan"></span>驾龄(年)</InputItem>
                        <div className="list">
                            <div className="radiolabel" ><span className="yuan"></span>意向业务</div>
                            {this.state.workType.map((res, i) => (
                                <Radio key={i} checked={this.state.businessType === res.value}
                                    onChange={() => this.setState({businessType: res.value})}>
                                    {res.label}
                                </Radio>
                            ))}
                        </div>
                        <Picker
                            extra="请选择意向城市区域"
                            data={cityData}
                            value={this.state.area}
                            format={(labels) => this.getArea(labels)}
                            onOk={v => this.inputChange(v, 'area')}
                        >
                            <List.Item arrow="horizontal" ><span className="yuan"></span>意向城市</List.Item>
                        </Picker>
                        
                        <InputItem
                            clear
                            placeholder="请输入"
                            value={this.state.note}
                            onChange={v => this.inputChange(v, 'note')}
                        ><span className="yuan"></span>其他</InputItem>
                        <button onClick={()=>this.submit()} className="submitok">确定</button>
                    </div>
                    <div>
                        <InputItem
                            clear
                            placeholder="请输入您的姓名"
                            value={this.state.userName1}
                            onChange={v => this.inputChange(v, 'userName1')}
                        ><span className="yuan"></span>姓名</InputItem>
                        <InputItem
                            clear
                            type="phone"
                            placeholder="请输入联系方式"
                            value={this.state.phone1}
                            onChange={v => this.inputChange(v, 'phone1')}
                        ><span className="yuan"></span>联系方式</InputItem>
                        <Picker
                            extra="请选择意向城市区域"
                            data={cityData}
                            value={this.state.area1}
                            format={(labels) => this.getArea1(labels)}
                            onOk={v => this.inputChange(v, 'area1')}
                        >
                            <List.Item arrow="horizontal" ><span className="yuan"></span>意向城市</List.Item>
                        </Picker>
                        <div className="list1">
                            <div className="radiolabel" ><span className="yuan"></span>从业经验</div>
                            <TextareaItem
                                rows={3}
                                value={this.state.project}
                                placeholder="请输入从业经验"
                                onChange={v => this.inputChange(v, 'project')}
                                autoHeight="autoHeight "
                            />
                        </div>
                        
                        <button onClick={()=>this.submit1()} className="submitok">确定</button>
                    </div>
                 </Tabs>
                 <div className="bottom">
                    <div  className="image"><img src={mtlogo}/></div>
                    <div  className="kefu">客服电话：<a href="tel:400-138-9889" className="phone">400-138-9889</a></div>
                    <div  className="image1"><img src={gzhewm} className="ewm"/><img src={xcxewm}/></div>
                 </div>
             </div>
         )
     }
 }
 


// WEBPACK FOOTER //
// ./src/container/IdentityBinding/RecruitDrivers.js